import { get, values } from 'lodash'
import { createSelector } from 'reselect'

export const getRevenueCenters = state => values(get(state, 'revenueCenter.byId'))

const getRevenueCenter = (state, revenueCenterId) => get(state, `revenueCenter.byId.${revenueCenterId}`, {})

export const makeGetRevenueCenter = () => createSelector([getRevenueCenter], (revenueCenter) => revenueCenter)

export const getIsRevenueCentersLoading = state => state?.revenueCenter?.isLoading ?? false
